// composables/useModal.js
import { ref, onUnmounted } from 'vue'

export function useModal() {
  const showModal = ref(false)

  const openModal = () => {
    showModal.value = true
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.overflow = 'hidden'
    document.body.style.paddingRight = `${scrollBarWidth}px`
  }

  const closeModal = () => {
    showModal.value = false
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }

  onUnmounted(() => {
    closeModal()
  })

  return {
    showModal,
    openModal,
    closeModal
  }
}
